import { cn } from '@utils/helpers';
import { ChevronDownIcon, ChevronUpIcon, ChevronsUpDownIcon } from 'lucide-react';
import { useCallback } from 'react';
import { useFragment } from 'react-relay';
import { fundsTableHeaderFragment } from './FundsTableHeader.relay';
import type { FundsTableHeaderPropsType } from './types';

const FundsTableHeader: React.FC<FundsTableHeaderPropsType> = (props: FundsTableHeaderPropsType) => {
  const header = useFragment(fundsTableHeaderFragment, props.header);

  if (typeof props.getHeaderCallback === 'function') {
    props.getHeaderCallback(header.tableheader);
  }

  const sortDir = useCallback(
    (col: string) => {
      if (props.sortInfo?.sortCol === col) {
        return props.sortInfo.sortOrder > 0 ? 'down' : 'up';
      }
      return 'default';
    },
    [props.sortInfo],
  );

  return (
    <thead>
      <tr>
        {header.tableheader.map((headerItem) => (
          <th
            key={headerItem.label}
            className={cn(
              `TableHeaderCell-${headerItem.col}`,
              ['category', 'distribution'].includes(headerItem.col) && 'max-[1100px]:hidden',
              headerItem.col === 'fundsname' && 'max-[1100px]:w-[60%]',
              headerItem.col === 'currency' && 'text-right [&>div]:float-right [&_img]:mr-[-5px]',
            )}
          >
            <button type="button" className="flex items-center gap-1" onClick={props.sortHandler.bind(null, headerItem.col)}>
              {headerItem.label}
              {headerItem.col !== 'isin' ? (
                sortDir(headerItem.col) === 'up' ? (
                  <ChevronUpIcon className="w-3 h-3" />
                ) : sortDir(headerItem.col) === 'down' ? (
                  <ChevronDownIcon className="w-3 h-3" />
                ) : (
                  <ChevronsUpDownIcon className="w-3 h-3" />
                )
              ) : null}
            </button>
          </th>
        ))}
      </tr>
    </thead>
  );
};

export { FundsTableHeader };
